if ("function" != typeof ModalBox) {
  class e extends HTMLElement {
    constructor() {
      if (
        ((window.inertElems = document.querySelectorAll("[data-js-inert]")),
        super(),
        (this.o = {
          show: 10,
          frequency: "day",
          enabled: !0,
          showOnce: !0,
          closeByKey: !0,
          disableScroll: !0,
          enableClose: !1,
          type: !1,
          blockTabNavigation: !1,
          openedModalBodyClass: "modal-opened",
          ...JSON.parse(this.dataset.options),
        }),
        "cookies" == this.o.type)
      ) {
        this.o.enabled = !1;
        const e = () => {
            (this.o.enabled = !0), this.show();
          },
          t = () => {
            window.Shopify.customerPrivacy.setTrackingConsent(!0, () => {});
          },
          o = () => {
            window.Shopify.customerPrivacy.setTrackingConsent(!1, () => {});
          },
          s = () => {
            window.Shopify.customerPrivacy.userCanBeTracked();
            window.Shopify.customerPrivacy.shouldShowBanner() && e();
          };
        this.querySelector("[data-js-cookies-accept]").addEventListener(
          "click",
          t
        ),
          this.querySelector("[data-js-cookies-decline]").addEventListener(
            "click",
            o
          ),
          window.Shopify.loadFeatures(
            [{ name: "consent-tracking-api", version: "0.1" }],
            (e) => {
              if (e) throw e;
              s();
            }
          );
      }
      if (this.o.enabled) {
        (this._modalKey = `modal-${document.location.hostname}-${this.id}`),
          (this._modalStorage = localStorage.getItem(this._modalKey)
            ? JSON.parse(localStorage.getItem(this._modalKey))
            : "empty"),
          this.querySelector("[data-content]") &&
            (this._modalText =
              this.querySelector("[data-content]").textContent);
        const e = new Date().getTime(),
          t = Math.round((e - this._modalStorage.shown) / 1e3);
        let o = !1;
        ("empty" == this._modalStorage ||
          ("day" == this.o.frequency && t > 86400) ||
          ("week" == this.o.frequency && t > 604800) ||
          ("month" == this.o.frequency && t > 2419200) ||
          this._modalStorage.content != this._modalText) &&
          (o = !0),
          o &&
            (setTimeout(() => {
              this.show();
            }, parseInt(1e3 * this.o.show)),
            setTimeout(() => {
              this.querySelectorAll("[data-js-close]").forEach((e) =>
                e.addEventListener("click", () => {
                  this.hide(this.o.showOnce);
                })
              );
            }, 100));
      } else
        0 == this.o.enabled &&
          this.querySelectorAll("[data-js-close]").forEach((e) =>
            e.addEventListener("click", () => {
              this.hide(this.o.showOnce);
            })
          );
      1 == this.o.enableClose &&
        this.querySelectorAll("[data-js-close]").forEach((e) =>
          e.addEventListener("click", () => {
            this.hide(this.o.showOnce);
          })
        ),
        this.o.closeByKey &&
          document.addEventListener("keydown", (e) => {
            27 == e.keyCode &&
              this.classList.contains("active") &&
              this.hide(this.o.showOnce);
          });
    }
    show() {
      this.setAttribute("style", ""),
        setTimeout(() => {
          this.classList.add("active"),
            this.o.disableScroll &&
              document.body.classList.add(this.o.openedModalBodyClass),
            this.o.blockTabNavigation &&
              window.inertElems.forEach((e) => {
                e.setAttribute("inert", "");
              });
        }, 10),
        setTimeout(() => {
          this.querySelector("[data-js-first-focus]") &&
            this.querySelector("[data-js-first-focus]").focus();
        }, 250);
    }
    hide(e = !1) {
      this.classList.remove("active"),
        document.body.classList.remove(this.o.openedModalBodyClass),
        setTimeout(() => {
          this.style.display = "none";
        }, 500),
        e &&
          !Shopify.designMode &&
          localStorage.setItem(
            this._modalKey,
            JSON.stringify({
              shown: new Date().getTime(),
              content: this._modalText,
            })
          ),
        window.inertElems.forEach((e) => {
          e.removeAttribute("inert");
        });
    }
  }
  if (void 0 === customElements.get("modal-box")) {
    document.querySelectorAll("modal-box").forEach((e) => {
      !0 === JSON.parse(e.dataset.options).appendToBody &&
        document.body.appendChild(e);
    }),
      customElements.define("modal-box", e);
  }
  document.addEventListener("shopify:section:select", (e) => {
    e.target.classList.contains("mount-popup") &&
      ((e.target.querySelector("modal-box").style.display = "block"),
      e.target.querySelector("modal-box").show());
  }),
    document.addEventListener("shopify:block:select", (e) => {
      e.target.hasAttribute("data-modal-box") &&
        ((e.target.style.display = "block"), e.target.show());
    }),
    document.addEventListener("shopify:block:deselect", (e) => {
      e.target.hasAttribute("data-modal-box") && e.target.hide();
    }),
    document.addEventListener("shopify:section:deselect", (e) => {
      e.target.classList.contains("mount-popup") &&
        e.target.querySelector("modal-box").hide();
    });
}
